module.exports = __webpack_public_path__ + "static/media/Blink_Artworks Logo_v1.4483fc24.jpg";